import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import calendar from "@/assets/svg_icons/calendar.svg";

interface ArticleCardProps {
  id: string;
  slug: string;
  tag: string;
  title: string;
  image?: string;
  date: Date;
  readingStatus: number;
  wordCount: number;
  summaryLevel?: string;
}

const ArticleCard = ({
  id,
  tag,
  title,
  image: _image,
  date,
  readingStatus,
  summaryLevel,
}: ArticleCardProps) => {
  const [readingStatusString, setReadingStatusString] = useState("");
  const [tagColor, setColor] = useState("");
  const [bgColor, setBgColor] = useState("");

  const tagCardStyle = {
    backgroundColor: tagColor,
    color: "var(--white)",
  };

  useEffect(() => {
    switch (tag) {
      case "world":
        setColor("var(--purple)");
        setBgColor("var(--light-blue-world)");
        break;
      case "business":
        setColor("var(--dark-rose)");
        setBgColor("var(--light-rose)");
        break;
      case "technology":
        setColor("var(--light-purple)");
        setBgColor("var(--light-cyan)");
        break;
      case "science":
        setColor("var(--rose)");
        setBgColor("var(--light-orange)");
        break;
      case "sports":
        setColor("var(--blue)");
        setBgColor("var(--light-blue-sports)");
        break;
      default:
        break;
    }
    switch (readingStatus) {
      case 0:
        setReadingStatusString("2 Tries Left");
        break;
      case 1:
        setReadingStatusString("1 Try Left");
        break;
      case 2:
        setReadingStatusString("0 Tries Left");
        break;
      default:
        setReadingStatusString("0 Tries Left");
    }
  }, [tag, readingStatus]);

  const cardStyle = {
    backgroundColor: bgColor,
    borderColor: readingStatus == 1 ? "var(--yellow)" : "var(--disabled)",
  };

  return (
    <>
      {/* 
        Reading Status = 2: Read twice - 0 Times left
        Reading Status = 1: Read once - 1 Time left
        Reading Status = 0: Never Read it - 2 Times left
       */}
      {readingStatus >= 2 ? (
        <div className={`article-card locked-article`} style={cardStyle}>
          <span>
            <div className="locked-article-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30px"
                height="30px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 14.5V16.5M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                  stroke="#dd5325"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </span>
          <div className="flex items-center justify-between mb-3">
            <span className="article-card-tag" style={tagCardStyle}>
              {tag}
            </span>
            {/* <span>{articleDate}</span> */}
            <span>{readingStatusString && readingStatusString} </span>
          </div>
          <h3 className="article-card-title mb-3">{title}</h3>
          {/* <div className="flex items-center">
        <span>&nbsp; • {wordCount && wordCount} Words</span>
      </div> */}

          <div className="mx-auto article-card-image">
            <img
              src={_image || "/assets/articles/article-1.png"}
              alt={title}
              width={150}
              height={150}
              className="group-hover:scale-110 transition duration-300 w-full"
            />
          </div>
        </div>
      ) : (
        <Link
          to="/articles/$slug"
          params={{ slug: id }}
          className={`article-card`}
          style={cardStyle}
          search={{ summaryLevel }}
        >
          <div className="flex items-center justify-between mb-2">
            <span className="article-card-tag" style={tagCardStyle}>
              {tag}
            </span>
            <span>{readingStatusString && readingStatusString} </span>
          </div>
          <span className="text-[14px] flex items-center mb-1">
            <span className=" mr-2">
              <img src={calendar} width={20} height={20} alt="Calendar Icon" />
            </span>
            <span className="leading-none article-date">
              {date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
          </span>
          <h3 className="article-card-title mb-3">{title}</h3>
          <div className="mx-auto article-card-image">
            <img
              src={_image || "/assets/articles/article-1.png"}
              alt={title}
              width={150}
              height={150}
              className="group-hover:scale-110 transition duration-300 w-full"
            />
          </div>
        </Link>
      )}
    </>
  );
};

export default ArticleCard;
